import { render, staticRenderFns } from "./setDateDoc.vue?vue&type=template&id=1a15c335&scoped=true"
import script from "./setDateDoc.vue?vue&type=script&lang=js"
export * from "./setDateDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a15c335",
  null
  
)

export default component.exports